import React, { useEffect, useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import ScrollToTopButton from './ScrollToTopButton';

const useCounter = (end, duration = 2000) => {
  const [count, setCount] = useState(0);



  useEffect(() => {
    let start = 0;
    const increment = end / (duration / 50); // 50ms interval
    const interval = setInterval(() => {
      start += increment;
      if (start >= end) {
        clearInterval(interval);
        setCount(end);
      } else {
        setCount(Math.ceil(start));
      }
    }, 50);

    return () => clearInterval(interval);
  }, [end, duration]);

  return count;
};

function Aboutus() {
  const [transform, setTransform] = useState({ rotateX: 0, rotateY: 0 });
  const handleMouseMove = (e) => {
    const { width, height, left, top } = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;

    const rotateX = ((y / height) - 0.5) * -20; // Negative for natural tilt
    const rotateY = ((x / width) - 0.5) * 20;

    setTransform({ rotateX, rotateY });
  };

  const resetTransform = () => {
    setTransform({ rotateX: 0, rotateY: 0 });
  };

  const [openIndex, setOpenIndex] = useState(0); // Default open

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const count1 = useCounter(20);
  const count2 = useCounter(35);
  const count3 = useCounter(26);
  const count4 = useCounter(100);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/Contact-Us'); // redirects to /about
  };
  return (
    <>
      <div className='aboutus-mainsection'>
        <ScrollToTopButton />
        <div className='container-fluid'>
          <div className='aboutus-bgsection'>
            <div className='container'>
              <h2 className='aboutus-header'>About Company</h2>
              <div>
                <h3 className='pages-head'> <NavLink to={'/'} className="about-s">HOME</NavLink> <img className='' src='../assets/images/icon_rightabout.png' alt='arrow' />ABOUT US</h3>
              </div>
            </div>
          </div>
        </div>
        <div className='aboutus-section2'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='aboutus-leftsection'>
                  <div className='aboutuse-settings'>
                    <img className='settingsicon' src='../assets/images/icons/settingsicon.png' alt='settings' />
                    <h3 className='abouthead'>ABOUT COMPANY</h3>
                  </div>
                  <h2 className='about2-head'>Bringing innovation & new ideas in IT</h2>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='aboutus-rightsection'>
                  <p className='aboutus-rightsection-txt'>4Sight Tech offers full range of technology & training methods for data analysis, business consultation, and strategic ways for business. Its an opportunity for new ventures. So 4Sight Tech offers full range of consultancy & training methods for data analysis, business consultation, and strategic ways for business. Its an opportunity for new ventures.</p>
                  <p className='aboutus-rightsection-txt'>With a focus on reliability, performance, and security, we help clients transform their ideas into scalable digital solutions. Whether it's building cloud infrastructure, developing custom software, or securing digital assets, we bring expertise, creativity, and passion to every project.

                    At 4 Sight Tech, innovation isn't just a goal—it’s our foundation.</p>
                </div>
              </div>
            </div>
            <img className='aboutus-im1' src='../assets/images/img1-us.webp' alt='about us' />
          </div>

          <div className='aboutus-mainsection3'>
            <div className='container'>
              <div className='aboutsec3-txt'>
                <p className='aboutsec3-subtxt'>We Are Proudly Operating On <span>26</span> Countries Globally Now</p>
              </div>
              <div className='about-section3'>
                <div className='row'>
                  <div className='col-md-3'>
                    <div className='about-section3-sub'>
                      <h3 className='about-section3-head'>{count1}K</h3>
                      <p className='about-section3-subtxt'>SESSION COMPLETED</p>
                    </div>
                  </div>
                  <div className='col-md-3'>
                    <div className='about-section3-sub'>
                      <h3 className='about-section3-head'>{count2}+</h3>
                      <p className='about-section3-subtxt'>COUNTRY OPERATION</p>
                    </div>
                  </div>
                  <div className='col-md-3'>
                    <div className='about-section3-sub'>
                      <h3 className='about-section3-head'>{count3}</h3>
                      <p className='about-section3-subtxt'>EXPERT CONSULTANTS</p>
                    </div>
                  </div>
                  <div className='col-md-3'>
                    <div className='about-section3-sub'>
                      <h3 className='about-section3-head'>{count4}%</h3>
                      <p className='about-section3-subtxt'>HAPPY CLIENTS</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='aboutus-section4'>
            <div className='container'>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='aboutus-sec4left'>
                    <img className='aboutus-sec4leftim1' src='../assets/images/img-ss3-us.jpg' alt='' />
                    <img className='aboutus-sec4leftim2' src='../assets/images/img-ss3-us1.jpg' alt='' />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='aboutus-sec4right'>
                    <div className='aboutuse-settings'>
                      <img className='settingsicon' src='../assets/images/icons/settingsicon.png' alt='settings' />
                      <h3 className='abouthead'>WE ARE COMPANY</h3>
                    </div>
                    <h3 className='aboutsec4-head'>Modern Idea Driven Technology Firm</h3>
                    <p className='aboutsec4-subtxt'>We are 4Sight Tech, as a promising IT Company we are serving over a decade with our tremendous skill in the software development industry.</p>
                    <div className='about-rightsec2'>
                      <div className='about-rightsec22'>
                        <img className='about-rightsec22im' src='../assets/images/icons/icon_tick2.png' alt='right' />
                        <p className='about-rightsec22imtxt'>Market Research</p>
                      </div>
                      <div className='about-rightsec22'>
                        <img className='about-rightsec22im' src='../assets/images/icons/icon_tick2.png' alt='right' />
                        <p className='about-rightsec22imtxt'>Competitive Analysis</p>
                      </div>
                    </div>
                    <div className='about-rightsec2'>
                      <div className='about-rightsec22'>
                        <img className='about-rightsec22im' src='../assets/images/icons/icon_tick2.png' alt='right' />
                        <p className='about-rightsec22imtxt'>Investment Decision</p>
                      </div>
                      <div className='about-rightsec22'>
                        <img className='about-rightsec22im' src='../assets/images/icons/icon_tick2.png' alt='right' />
                        <p className='about-rightsec22imtxt'>Reporting & Analysis</p>
                      </div>
                    </div>
                    <button className='about-rightsec22bt' onClick={handleRedirect}>Let’s Work Together</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='aboutus-section5'>
            <div className='container'>
              <div className='aboutus-section4sec'>
                <div>
                  <h3 className='project-head'>Have a project in mind?</h3>
                  <p className='project-subhead'>Let’s talk to us</p>
                </div>
                <button className='projectsecbt'>
                  <p>More About Us</p>
                  <img src='../assets/images/icons/Icon_arrow_right.png' alt='bt' />
                </button>
                <img className='projectsecbtim222' src='../assets/images/man-us.png' alt='bt' />
              </div>

              <div className='section4-mainse'>
                <div className='section55-mainsubtextsec'>
                  <h3 className='section55-subhead'> EXPLORE OUR FEATURES </h3>
                </div>
                <h2 className='section55-mainhead'>We are continuously improving our skills in technology</h2>

                <div className='row'>
                  <div className='col-md-4'>
                    <div className='section55-subs'>
                      <div className="d-flex">
                        <div className="flex-shrink-0 section55-subsbg">
                          <img className='section55-subsim' src="../assets/images/icons-about/CustomFeaturing.png" alt="..." />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h3 className='section55-subsimhead'>Custom Featuring</h3>
                          <p className='section55-subsimsubhead'>Tailored web features to match your business goals,
                            enhancing functionality and user experience.</p>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='section55-subs'>
                      <div className="d-flex">
                        <div className="flex-shrink-0 section55-subsbg">
                          <img className='section55-subsim' src="../assets/images/icons-about/CyberSecurity.png" alt="..." />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h3 className='section55-subsimhead'>Cyber Security</h3>
                          <p className='section55-subsimsubhead'>Advanced protection against cyber threats,
                            keeping your digital assets safe and secure.</p>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='section55-subs'>
                      <div className="d-flex">
                        <div className="flex-shrink-0 section55-subsbg">
                          <img className='section55-subsim' src="../assets/images/icons-about/DatabaseManagement.png" alt="..." />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h3 className='section55-subsimhead'>Database Management</h3>
                          <p className='section55-subsimsubhead'>Reliable data handling with optimal performance,
                            ensuring integrity, availability, and scalability.</p>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div className='col-md-4'>
                    <div className='section55-subs'>
                      <div className="d-flex">
                        <div className="flex-shrink-0 section55-subsbg">
                          <img className='section55-subsim' src="../assets/images/icons-about/GlobalReach.png" alt="..." />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h3 className='section55-subsimhead'>Global Reach</h3>
                          <p className='section55-subsimsubhead'>Expand your digital presence worldwide,
                            with robust, scalable, and secure infrastructure.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='section55-subs'>
                      <div className="d-flex">
                        <div className="flex-shrink-0 section55-subsbg">
                          <img className='section55-subsim' src="../assets/images/icons-about/ServerManagement.png" alt="..." />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h3 className='section55-subsimhead'>Server Management</h3>
                          <p className='section55-subsimsubhead'>Efficient server monitoring and optimization,
                            guaranteeing uptime, speed, and performance.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <div className='section55-subs'>
                      <div className="d-flex">
                        <div className="flex-shrink-0 section55-subsbg">
                          <img className='section55-subsim' src="../assets/images/icons-about/CloudComputing.png" alt="..." />
                        </div>
                        <div className="flex-grow-1 ms-3">
                          <h3 className='section55-subsimhead'>Cloud Computing</h3>
                          <p className='section55-subsimsubhead'>Flexible, scalable, and secure cloud solutions,
                            powering innovation and remote collaboration.</p>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='aboutus-faqMainsection'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-6'>
                <div className='faq-leftsection'>
                  <div className=''>
                    <div className='faq-settings'>
                      <img className='faqsettingsicon' src='../assets/images/icons/settingsicon.png' alt='settings' />
                      <h3 className='faqhead'>FREQUENTLY ASKED QUESTIONS</h3>
                    </div>
                    <h3 className='fqasec4-head'>FREQUENTLY ASKED QUESTIONS</h3>
                    <p className='faqsec4-subtxt'>Ask Questions Here</p>
                  </div>
                  <img className='faqimage' src='../assets/images/img-faq1.png' alt='faq' />
                </div>
              </div>
              <div className='col-md-6'>
                <div className="faq-container container">
                  <div className="faq-item">
                    <button
                      className={`faq-question btn w-100 text-start d-flex justify-content-between align-items-center ${openIndex === 0 ? 'active' : ''
                        }`}
                      onClick={() => toggle(0)}
                    >
                      What services does 4 Sight Tech offer?
                      <span>{openIndex === 0 ? '−' : '+'}</span>
                    </button>
                    {openIndex === 0 && (
                      <div className="faq-answer px-3 py-2">
                        4Sight Tech We specialize in Cloud Services, Software Development, Cybersecurity, and Quality Assurance to help businesses build secure, scalable, and high-performing digital solutions.
                      </div>
                    )}
                  </div>

                  <div className="faq-item ">
                    <button
                      className={`faq-question btn w-100 text-start d-flex justify-content-between align-items-center ${openIndex === 1 ? 'active' : ''
                        }`}
                      onClick={() => toggle(1)}
                    >
                      Do you provide custom software solutions?
                      <span>{openIndex === 1 ? '−' : '+'}</span>
                    </button>
                    {openIndex === 1 && <div className="faq-answer px-3 py-2">
                      Yes! We tailor software development to match your business needs—whether it’s a web platform, enterprise system, or cloud-based application.
                    </div>}
                  </div>

                  <div className="faq-item">
                    <button
                      className={`faq-question btn w-100 text-start d-flex justify-content-between align-items-center ${openIndex === 2 ? 'active' : ''
                        }`}
                      onClick={() => toggle(2)}
                    >
                      How do you ensure data security in your solutions?
                      <span>{openIndex === 2 ? '−' : '+'}</span>
                    </button>
                    {openIndex === 2 && <div className="faq-answer px-3 py-2">
                      Our cybersecurity approach includes end-to-end encryption, threat detection, and secure cloud architecture to keep your data safe and compliant.
                    </div>}
                  </div>

                  <div className="faq-item mb-3">
                    <button
                      className={`faq-question btn w-100 text-start d-flex justify-content-between align-items-center ${openIndex === 3 ? 'active' : ''
                        }`}
                      onClick={() => toggle(3)}
                    >
                      Can we get post-project support and maintenance?
                      <span>{openIndex === 3 ? '−' : '+'}</span>
                    </button>
                    {openIndex === 3 && <div className="faq-answer px-3 py-2">
                      Absolutely. We provide continuous support, updates, and maintenance to ensure your systems run smoothly long after launch.
                    </div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Aboutus;